import { SlotConstants,SlotEventConstants } from "@quest/slot-core";
import { dispatcher, ingenuity } from "@quest/base-core";
import {
  BigWinController,
  SlotEventConstantsBehavior,
  SlotConstantsBehavior,
  SoundConstant,
  MeterBehavior,
} from "@quest/murka-games-behavior-panther/dist";

import { GameParserModel } from "../Platform/GameParserModel";
import { Linear } from "@quest/pixi-bridge";
import { eventDispatchers } from "../Constants/EventDispatchers";

export class BigWinControllerGame extends BigWinController {
  /**
   * This method is use to start tickup on bigwin
   */

  public initializeBigWin(): void {
    this.bigWinMeter = this.view.getMeterById("bigWinMtr") as MeterBehavior;
    this.bigWinContainer = this.view.getContainerByID("bigWinContainer");
    this.bgLoopSpineContainer = this.view.getContainerByID("bgLoopSpineContainer");

    this.bgLoopSpine = this.view.getSpineById("BIGWIN_BG_SPINE");
    this.textAndCharSpine = this.view.getSpineById("text_Man_Spine");

    this.bigWinMainContainer = this.view.getContainerByID("bigWinMainContainer");
    this.bigWinMeterContainer = this.view.getContainerByID("bigWinMeterContainer");
    this.bgSpineContainer = this.view.getContainerByID("backgroundSpineContainer");
    !ingenuity.deviceEnv.isDesktop && this.initializePortraitComponent();
  }

  protected initializePortraitComponent(): void {
    this.bgLoopPortraitSpine = this.view.getSpineById("big_win_portrait");
    this.textAndCharacterSpinePortrait = this.view.getSpineById("text_Man_Spine_Port");
  }
  /**
   * overrided to hide portrait banner
   */
  protected playBgSpineInLoop() {
    super.playBgSpineInLoop();
    dispatcher.fireEvent(eventDispatchers.HIDE_TOP_LOGO_ON_BANNER);
  }
  /**
   * handle bigwin fadding presentation order
   */
  protected hideBigWin(): void {
    this.textAndCharSpine.onComplete.addOnce(() => {
      this.updateBlurBg();
      dispatcher.fireEvent(eventDispatchers.SHOW_TOP_LOGO_ON_BANNER);
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
      }
      this.bigWinMeter.visible = false;
      this.hideBigWinWithFadeOutEffect();
    }, this);
    ingenuity.configData.enableStageClick = false;
    dispatcher.fireEvent(SlotEventConstantsBehavior.DISABLE_STAGE_CLICK);
    this.hideBigWinBasedOnState();
  }
  /**
   * overrided to handle big win fade
   */
  protected hideBigWinWithFadeOutEffect(): void {
    const bigwinmetercontainer = this.view.getContainerByID("bigWinMeterContainer");
    const bigwinmetercontainerFadeOutTween = ingenuity.currentGame.add
      .tween(bigwinmetercontainer)
      .to({ alpha: 0 }, SlotConstantsBehavior.DURATION_400, Linear.None, true, 0, 0, false);
    bigwinmetercontainerFadeOutTween.onComplete.addOnce(() => {
      bigwinmetercontainerFadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(bigwinmetercontainerFadeOutTween);
    }, this);
    const bigWinFadeOutTween = ingenuity.currentGame.add
      .tween(this.bigWinMainContainer)
      .to({ alpha: 0 }, SlotConstantsBehavior.DURATION_400, Linear.None, true, 0, 0, false);
    bigWinFadeOutTween.onComplete.addOnce(() => {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
      this.resetElements();
      bigWinFadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(bigWinFadeOutTween);
    }, this);
  }
  /**
   * overrided to handle big win hide
   */
  protected hideBigWinBasedOnState(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.FADE_OUT_SOUND, {
        id: SoundConstant.BASEGAME_BGMLOOP,
        vol: 1,
        key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
      });
      this.fadeInBaseGameSound();
      this.model.setIsBigWinRunning(false);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_AFTER_BIGWIN);
    }
  }
  /**
   * overrided to change the win amount tag 
   */
  protected startBigWinTickup(): void {
    this.bigWinMeter.setValue(0);
    this.bigWinMeter.visible = true;
    this.bigWinMeterContainer.visible = true;
    this.bigWinMeterContainer.alpha = 1;
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ENABLE_STAGE_CLICK);
      this.currentWinAmountTickUp = (ingenuity.parserModel as GameParserModel).getTotalCascadeWin();
      this.bigWinMeter.startTick(
        this.currentWinAmountTickUp,
        true,
        false,
        SlotConstantsBehavior.WINTICKUP_BG_2,
        true,
        this.bigWinPresentationComplete.bind(this)
      );
    }
  }
}
